import { createMuiTheme } from "@material-ui/core";
import baseThemeJson from './theme.json';
import Color from 'color';
import Settings from "../../settings.yml";

const baseTheme = createMuiTheme(baseThemeJson);

const primaryMain = Settings.colorPrimary;
const primaryColor = Color(primaryMain);

const secondaryMain = Settings.colorSecondary;
const secondaryColor = Color(secondaryMain);

const tertiaryColor = Color(Settings.colorPrimary).mix(
  Color(Settings.colorSecondary)
).rotate(-180).lighten(0.3).desaturate(0.1).rgb();
const tertiaryMain = tertiaryColor.string();

baseTheme.overrides.MuiTableRow.hover["&$hover"]["&:hover"]['backgroundColor'] = Color(primaryMain).fade(0.9).rgb().string();

const theme = createMuiTheme({
  ...baseTheme,
  palette: {
    ...baseTheme.palette,
    primary: {
      main: primaryMain,
      light: primaryColor.lighten(0.3).rgb().string(),
      dark: primaryColor.darken(0.3).rgb().string(),
      contrastText: baseTheme.palette.getContrastText(primaryMain),
    },
    secondary: {
      main: secondaryMain,
      light: secondaryColor.lighten(0.3).rgb().string(),
      dark: secondaryColor.darken(0.3).rgb().string(),
      contrastText: baseTheme.palette.getContrastText(secondaryMain),
    },
    tertiary: {
      main: tertiaryMain,
      light: tertiaryColor.lighten(0.3).rgb().string(),
      dark: tertiaryColor.darken(0.3).rgb().string(),
      contrastText: baseTheme.palette.getContrastText(tertiaryMain),
    }
  }
})

export default theme;